import { render, staticRenderFns } from "./Indigator.vue?vue&type=template&id=ed0ddfda&scoped=true&"
import script from "./Indigator.vue?vue&type=script&lang=js&"
export * from "./Indigator.vue?vue&type=script&lang=js&"
import style0 from "./Indigator.vue?vue&type=style&index=0&id=ed0ddfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0ddfda",
  null
  
)

export default component.exports